// @flow

export const getSpecialTypes = (state: Object) => state.service.specialContactsTypes;

export const getSpecialContactsTypes = (state: Object) => getSpecialTypes(state).list.content;

export const getCurrentSpecialContactsType = (state: Object) => getSpecialTypes(state).current;

export const getShowSpecialContactsTypeModal = (state: Object) =>
  getSpecialTypes(state).modals.showTypeModal;

export const getShowDeleteSpecialContactsTypeModal = (state: Object) =>
  getSpecialTypes(state).modals.showDeleteModal;
